var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"codeeditor"},[_c('div',_vm._g({ref:"editable",staticClass:"codeeditor-content",attrs:{"contenteditable":""}},_vm.listeners))])
}
var staticRenderFns = []

export { render, staticRenderFns }